export default "__VITE_ASSET__DgdCT6gW__"